<template>
  <div class="mb-1">
    <NavigationBar :info="navigationInfo"/>
    <StatusBar/>
    <InfoBar/>
    <InfoSnackbar/>
    <BreadcrumbsBar/>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import saveFunctions from "@/data/save/mixins/saveFunctions.js";
import InfoBar from "@/frame/navigation/components/InfoBar";
import NavigationBar from "@/frame/navigation/components/NavigationBar";
import StatusBar from "@/frame/navigation/components/StatusBar";
import InfoSnackbar from "@/frame/messages/components/InfoSnackbar";
import BreadcrumbsBar from "@/frame/navigation/components/BreadcrumbsBar";
export default {
  components: {
    InfoBar,
    InfoSnackbar,
    NavigationBar,
    StatusBar,
    BreadcrumbsBar
  },
  props: {
    navigationInfo: Object
  },
  mixins: [saveFunctions, apptheme],
  computed: {
    ...mapGetters([
      "getCurrentPage",
      "getPreviousPage",
      "getUser",
      "getDetailSave"
    ])
  },
  created() {
    // MAKE save status return to TRUE
    // detail pages (EDIT)
    // to make it avialble to next user
    let userdid = this.getUser.basic.did;
    let userdoc = null;
    if (this.getDetailSave !== null) {
      userdoc = this.getDetailSave.rev.udid;
    }
    if (userdoc !== null && userdid === userdoc) {
      if (
        this.getPreviousPage === "/riskdetail" ||
        this.getPreviousPage === "/actiondetail" ||
        this.getPreviousPage === "/budgetdetail" ||
        this.getPreviousPage === "/plandetail" ||
        this.getPreviousPage === "/engdetail" ||
        this.getPreviousPage === "/opsdetail" ||
        this.getPreviousPage === "/orderdetail" ||
        this.getPreviousPage === "/incidentdetail" ||
        this.getPreviousPage === "/worktooldetail" ||
        this.getPreviousPage === "/workrequestdetail" ||
        this.getPreviousPage === "/workcalldetail" ||
        this.getPreviousPage === "/assetdetail" ||
        this.getPreviousPage === "/companydetail" ||
        this.getPreviousPage === "/equipdetail" ||
        this.getPreviousPage === "/programdetail" ||
        this.getPreviousPage === "/engineeringdetail" ||
        this.getPreviousPage === "/facilitydetail" ||
        this.getPreviousPage === "/maintstrategydetail" ||
        this.getPreviousPage === "/maintplandetail" ||
        this.getPreviousPage === "/materialdetail" ||
        this.getPreviousPage === "/hazarddetail" ||
        this.getPreviousPage === "/proceduredetail"
      ) {
        // console.log("");
        // console.log(">>> CLOSE SAVED DATA <<<");
        // this.setDocumentClosed();
      }
    }
  }
};
</script>
